import React from "react";
import data from "./projectData";
import ProjectMiniCard from "./projectCard";
import { motion } from "framer-motion";
import { fadeInUp, staggerContainer, viewportOnce } from "../motionVariants";

export default function Projects(){
    const featured = data.slice(0, 4);
    const rest = data.slice(4);

    return(
        <div id="projectRoot">
            <div className="sectionHead">
                <span className="eyebrow">Featured Work</span>
                <h2 className="sectionTitle" id="projectText">Projects</h2>
                <p className="sectionSub">Problem, approach, and what shipped — the ones I'd actually walk you through.</p>
            </div>

            <motion.div
                id="featuredGrid"
                variants={staggerContainer}
                initial="hidden"
                whileInView="visible"
                viewport={viewportOnce}
            >
                {featured.map((obj) => (
                    <motion.div className="featuredCard" key={obj.name} variants={fadeInUp}>
                        <div className="featuredMedia">
                            <img src={obj.img} alt={`${obj.name} preview`} className="featuredImg" />
                        </div>
                        <div className="featuredBody">
                            <div className="featuredHead">
                                <h3 className="featuredName">{obj.name}</h3>
                                <div className="featuredTechRow">
                                    {obj.tech.split(",").map((t) => (
                                        <span className="techChip" key={t.trim()}>{t.trim()}</span>
                                    ))}
                                </div>
                            </div>
                            <dl className="featuredFacts">
                                <div>
                                    <dt>Problem</dt>
                                    <dd>{obj.problem || obj.desc}</dd>
                                </div>
                                {obj.solution && (
                                    <div>
                                        <dt>Approach</dt>
                                        <dd>{obj.solution}</dd>
                                    </div>
                                )}
                                {obj.impact && (
                                    <div>
                                        <dt>Impact</dt>
                                        <dd>{obj.impact}</dd>
                                    </div>
                                )}
                            </dl>
                            {obj.link ? (
                                <a href={obj.link} target="_blank" rel="noreferrer">
                                    <motion.div className="featuredVisit" whileHover={{ scale: 1.03 }}>
                                        {obj.link.includes("github.com") ? "View on GitHub" : "Visit Project"}
                                    </motion.div>
                                </a>
                            ) : (
                                <span className="featuredVisit featuredVisitDisabled">Link coming soon</span>
                            )}
                        </div>
                    </motion.div>
                ))}
            </motion.div>

            <div id="moreProjectsWrap">
                <h3 id="moreProjectsText">More Projects</h3>
                <motion.div
                    id="cardBox"
                    variants={staggerContainer}
                    initial="hidden"
                    whileInView="visible"
                    viewport={viewportOnce}
                >
                    {rest.map((obj) => (
                        <motion.div key={obj.name} variants={fadeInUp}>
                            <ProjectMiniCard obj={obj} />
                        </motion.div>
                    ))}
                </motion.div>
            </div>
        </div>
    )
}
